/** Formats an amount as Danish kroner, e.g. 1234 -> "1.234 kr.". Whole kroner, no decimals —
 *  a deliberate choice over the design mockup's "260,00,-": ticket prices here are always
 *  whole kroner, so øre decimals would be dead weight. */
export const formatDkkPrice = (amount: number): string =>
  amount.toLocaleString('da-DK') + ' kr.';
